<template lang="pug">
v-card(:to="to", width="100%", max-width="280px", flat)
  img.mb-1.part-card-img.rounded-lg(:src="img", :alt="title")
  .part-card-title.black--text.text-center.text-body-1.d-flex.justify-center.align-center.font-weight-bold.mx-auto {{ title }}
</template>

<script>
import Tooltip from "../tools/Tooltip.vue";

export default {
  props: {
    img: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
  },
  components: {
    Tooltip,
  },
};
</script>

<style>
.part-card-title {
  max-width: 265px;
  height: 42px;
  position: relative;
}

.part-card-img {
  aspect-ratio: 16/12;
  border: 1px solid #ccc;
  width: 100%;
  object-fit: contain;
}
</style>